import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'

// Isolates the B2B logo-upload funnel's Mixpanel transforms from mixpanel.helper.ts's
// shared switch, which covers every other event in the app. A `switch` statement can't be
// spread, so `getTransformedProperties` consults this lookup by `event_type` before falling
// through to its own switch.
export const b2bLogoUploadTransforms: Record<string, (properties: Record<string, unknown>) => Record<string, unknown>> =
  {
    [TELEMETRY_EVENT_NAMES.CUSTOMIZATION_PAGE_LOGO_UPLOAD]: properties => {
      return {
        event_type: TELEMETRY_EVENT_NAMES.CUSTOMIZATION_PAGE_LOGO_UPLOAD,
        event_name: 'Customization Page Logo Uploaded',
        logoUploaded: (properties?.context as { logoUploaded?: boolean } | undefined)?.logoUploaded,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FILE_SELECTED]: properties => {
      const context = properties?.context as
        | {
            file_type?: string
            file_size?: number
            input_method?: string
            is_replacement?: boolean
            product_id?: string
          }
        | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FILE_SELECTED,
        event_name: 'Logo Upload File Selected',
        file_type: context?.file_type,
        file_size: context?.file_size,
        input_method: context?.input_method,
        is_replacement: context?.is_replacement,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_BUTTON_CLICK]: properties => {
      const context = properties?.context as { product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_BUTTON_CLICK,
        event_name: 'Logo Upload Button Click',
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_BACKGROUND_WARNING_SHOWN]: properties => {
      const context = properties?.context as { product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_BACKGROUND_WARNING_SHOWN,
        event_name: 'Logo Background Warning Shown',
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_BACKGROUND_WARNING_ACTION]: properties => {
      const context = properties?.context as { action?: string; product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_BACKGROUND_WARNING_ACTION,
        event_name: 'Logo Background Warning Action',
        action: context?.action,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FMS_SUCCESS]: properties => {
      const context = properties?.context as
        | { asset_id?: string; duration_ms?: number; is_retry?: boolean; product_id?: string }
        | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FMS_SUCCESS,
        event_name: 'Logo Upload FMS Success',
        asset_id: context?.asset_id,
        duration_ms: context?.duration_ms,
        is_retry: context?.is_retry,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FMS_FAILURE]: properties => {
      const context = properties?.context as
        | { error_type?: string; error_log?: string; is_retry?: boolean; product_id?: string }
        | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_UPLOAD_FMS_FAILURE,
        event_name: 'Logo Upload FMS Failure',
        error_type: context?.error_type,
        error_log: context?.error_log,
        is_retry: context?.is_retry,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_CONTENT_CHECK_RESULT]: properties => {
      const context = properties?.context as
        | {
            approved?: boolean
            reject_reason?: string
            reject_code?: number
            asset_id?: string
            check_type?: string
            product_id?: string
          }
        | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_CONTENT_CHECK_RESULT,
        event_name: 'Logo Content Check Result',
        approved: context?.approved,
        reject_reason: context?.reject_reason,
        reject_code: context?.reject_code,
        asset_id: context?.asset_id,
        check_type: context?.check_type,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_FAILURE_MODAL_ACTION]: properties => {
      const context = properties?.context as { modal_type?: string; action?: string; product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_FAILURE_MODAL_ACTION,
        event_name: 'Logo Failure Modal Action',
        modal_type: context?.modal_type,
        action: context?.action,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_DELETE_PROMPT_SHOWN]: properties => {
      const context = properties?.context as { asset_id?: string; product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_DELETE_PROMPT_SHOWN,
        event_name: 'Logo Delete Prompt Shown',
        asset_id: context?.asset_id,
        product_id: context?.product_id,
      }
    },
    [TELEMETRY_EVENT_NAMES.LOGO_DELETE_ACTION]: properties => {
      const context = properties?.context as { action?: string; asset_id?: string; product_id?: string } | undefined
      return {
        event_type: TELEMETRY_EVENT_NAMES.LOGO_DELETE_ACTION,
        event_name: 'Logo Delete Action',
        action: context?.action,
        asset_id: context?.asset_id,
        product_id: context?.product_id,
      }
    },
  }
